export const DOMAIN_CALCULATION = "CALCULATION";
